/**
 * @generated SignedSource<<c63e7424eac9b8d12d9622af098d89a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftCreatorTile_nftCreator$data = {
  readonly address: {
    readonly address: string | null;
    readonly publicProfile: {
      readonly bio: string | null;
      readonly heroImage: {
        readonly path: string | null;
      } | null;
      readonly profileName: string | null;
      readonly username: string | null;
    } | null;
    readonly publicProfileUrl: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftAvatarCircle_address">;
  } | null;
  readonly nftItemCount: number | null;
  readonly " $fragmentType": "NftCreatorTile_nftCreator";
};
export type NftCreatorTile_nftCreator$key = {
  readonly " $data"?: NftCreatorTile_nftCreator$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftCreatorTile_nftCreator">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftCreatorTile_nftCreator",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftAvatarCircle_address"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bio",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Photo",
              "kind": "LinkedField",
              "name": "heroImage",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "path",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicProfileUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nftItemCount",
      "storageKey": null
    }
  ],
  "type": "NftCreatorsSearchResult",
  "abstractKey": null
};

(node as any).hash = "5aac66d3c81e8d0b5c74a07031c92538";

export default node;
